import { Control, FieldPath, FieldValues } from 'react-hook-form';

import { validateEmail } from '@/shared/lib/validators';
import { ControlledTextField } from '@/shared/ui/form/TextField';

type EmailInputProps<T extends FieldValues> = {
  control: Control<T>;
  fieldName?: FieldPath<T> | string;
  isDisabled: boolean;
} & FieldValues;

export const EmailInput = <T extends FieldValues>({ control, fieldName = 'email', isDisabled }: EmailInputProps<T>) => {
  return (
    <ControlledTextField
      label="Email"
      slotProps={{
        input: {
          inputProps: {
            autoComplete: 'username',
          },
        },
      }}
      control={control}
      disabled={isDisabled}
      fieldName={fieldName as FieldPath<T>}
      placeholder="Enter your email"
      showEndAdornmentOnError={false}
      validator={validateEmail}
      variant="outlined"
    />
  );
};
